import './DeleteApplicationModal.scss';
export class DeleteApplicationModalController {
    static $inject = ['close', 'shortName', 'AiAgentService'];
    constructor(close, shortName, AiAgentService) {
        this.close = close;
        this.shortName = shortName;
        this.AiAgentService = AiAgentService;
        this.isCheckedBox = false;
        this.isAiAgent = false;
        this.$onInit = async () => {
            this.isAiAgent = await this.AiAgentService.checkAiAgentAsync();
        };
        this.getCheckedBox = async (event) => {
            this.isCheckedBox = !event.srcElement.checked;
        };
        this.closeModal = async () => {
            if (this.isCheckedBox) {
                this.close(true);
            }
        };
    }
}
DeleteApplicationModalController.$inject = ['close', 'shortName', 'AiAgentService'];
